import MuiAlert, { AlertProps } from '@mui/material/Alert'

/**
 * Renders alert
 * @param props Alert properties
 */

export default function Alert(props: AlertProps) {
  return (
    <MuiAlert data-test="alert" elevation={6} variant="filled" severity={props.severity} sx={{ marginBottom: '12px', zIndex: 100 }}>
      {props.children}
    </MuiAlert>
  )
}
